import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { TuiDropdownContent, TuiDropdownOptionsDirective, TuiTextfield } from '@taiga-ui/core';
import { TuiLanguageSwitcherService } from '@taiga-ui/i18n';
import { TuiChevron, TuiDataListWrapper, TuiFlagPipe } from '@taiga-ui/kit';
import { first, map, Observable } from 'rxjs';
import { availableLocales } from 'src/app/locale/config/available-locales';
import { LocaleConfig } from 'src/app/locale/models/locale-config';

@Component({
  selector: 'pxc-locale-picker-dropdown',
  imports: [
    ReactiveFormsModule,
    TuiDataListWrapper,
    TuiDropdownContent,
    TuiDropdownOptionsDirective,
    TuiTextfield,
    TuiFlagPipe,
    FormsModule,
    TuiChevron,
    UpperCasePipe,
    AsyncPipe,
  ],
  templateUrl: './locale-picker-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalePickerDropdownComponent {
  readonly availableLocales = availableLocales;

  private readonly translocoService = inject(TranslocoService);
  private readonly switcher = inject(TuiLanguageSwitcherService);

  readonly activeLanguage$: Observable<string> = this.translocoService.langChanges$;
  readonly activeLocale$: Observable<LocaleConfig> = this.activeLanguage$.pipe(
    map((activeLang) => {
      const lang = activeLang ?? this.translocoService.getActiveLang();
      return this.availableLocales.find((locale) => locale.code === lang) ?? this.availableLocales[0];
    }),
  );

  changeLocale(selectedLocale: LocaleConfig): void {
    const langKey = selectedLocale.code;
    this.translocoService
      .load(langKey)
      .pipe(first())
      .subscribe(() => {
        this.translocoService.setActiveLang(langKey);
        this.switcher.setLanguage(selectedLocale.tuiConfig.languageName);
      });
  }
}
